import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ProgressBar, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import SliderMyCoursesListing from "../LearningPaths/SliderMyCoursesListing";
import SliderMyLearningPathListing from "../LearningPaths/SliderMyLearningPathListing";
import {
  getMyCoursesBroker,
  getMyCourses,
  setFavoriteCourses,
  getMyLearningPaths,
  getMyLearningPathsClear,
  getMyCoursesClear,
  getSelectedCatId,
  getProductCategoriesData,
  getProductCategoriesDataClear,
} from "../../redux/courses/actions";
import {
  convertHoursToMins,
  convertTimeFormat,
  getProcureInfo,
  goToLPDetailUtil,
  ProductCardPriceInfo,
  SessionKeys,
} from "../../utils/AppUtils";
import ExploreCardSection from "../LearningPaths/ExploreCardSection";

import _ from "lodash";
import Loader from "../Loader/Loader";
import ShimmerCardBody from "../Layouts/ShimmerCardBody";
import {
  getNonMyOBLPListing,
  getNonMyOBLPListingClear,
} from "../../redux/learningPath/actions";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import { useTranslation } from "react-i18next";

const MyAreaSection = ({ fetchData }) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const myCoursesData = useSelector((state) => state.courses.myCourses);
  const myLearningPathsData = useSelector(
    (state) => state.courses.myLearningPaths
  );
  const brokerMyCourses = useSelector((state) => state.courses.myCoursesBroker);
  var myCourseRes = useSelector((state) => state.courses.productCategoriesData);
  const myNonOblpListing = useSelector(
    (state) => state.learningPath.myNonOblpListing
  );
  const activeLanguage = useSelector((state) => state.home.activeLanguage);

  const userRole = useSelector((state) => state.user.role);
  const [pageType, setPageType] = useState("course");
  const [closeChildModal, setCloseChildModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [progressCoursesList, setProgressCoursesList] = useState([]);
  const [allCoursesList, setAllCoursesList] = useState([]);
  const [startCoursesList, setStartCoursesList] = useState([]);
  const [inProgressCoursesList, setInProgressCoursesList] = useState([]);
  const [completedCoursesList, setCompletedCoursesList] = useState([]);
  const [overDueCoursesList, setOverDueCoursesList] = useState([]);
  const [allLearningPathList, setAllLearningPathList] = useState([]);
  const [startLearningPathList, setStartLearningPathList] = useState([]);
  const [inProgressLearningPathList, setInProgressLearningPathList] = useState(
    []
  );
  const [completedLearningPathList, setCompletedLearningPathList] = useState(
    []
  );
  const [overDueLearningPathList, setOverDueLearningPathList] = useState([]);
  const [isStartCourseSet, setIsStartCourseSet] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isCourseLoading, setIsCourseLoading] = useState(true);
  const [isLPLoading, setIsLPLoading] = useState(true);

  useEffect(() => {
    if (!_.isEmpty(authBroker) && fetchData) {
      // dispatch(
      //   getMyCourses({
      //     ecom: {
      //       module: "getMyCourses",
      //       broker: false,
      //       postData: {
      //         user_id: authBroker?.payload?.user?.user_id,
      //         email: authBroker.payload.user.email,
      //       },
      //     },
      //     broker: {
      //       module: "getMyCourses",
      //       broker: true,
      //       postData: {
      //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      //       },
      //     },
      //   })
      // );
      dispatch(
        getProductCategoriesData({
          module: "getProductCategoriesDataMyCourse",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            category_id: [],
            provider_id: "",
            search: "",
            sort: 1,
            page_size: 100,
            page: 1,
          },
        })
      );
      setIsCourseLoading(true);
      // dispatch(
      //   getMyLearningPaths({
      //     module: "getMyLearningPaths",
      //     postData: {
      //       token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      //     },
      //   })
      // );
      dispatch(
        getNonMyOBLPListing({
          URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_MY_LP_LISTING}`,
          payload: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            sort: 1,
            page_size: 20,
            page: 0,
            search: "",
            is_onboarding: 0,
            language: activeLanguage ? activeLanguage : "",
          },
          isJSON: true,
          method: "post",
        })
      );
      setIsLPLoading(true);
      // dispatch(getMyCoursesBroker({
      //     module: 'getMyCourses',
      //     broker: true,
      //     postData: {
      //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
      //     }
      // }))
    }
  }, [dispatch, authBroker, fetchData,activeLanguage]);

  useEffect(() => {
    // console.log('Ecom courses', myCoursesData)
    if (!_.isEmpty(myCoursesData)) {
      let allCourseList = [];
      let startCourseList = [];
      let inProgressCourseList = [];
      let completedCourseList = [];
      let overDueCourseList = [];
      for (let courses of myCoursesData) {
        if (courses.status === "success") {
          const coursesList = courses.payload.payload;
          if (!_.isEmpty(coursesList)) {
            allCourseList = [...coursesList, ...allCourseList];
            for (let course of coursesList) {
              if (course.durationUnit === "Hours") {
                course.duration = convertHoursToMins(course.duration);
              }
              course.duration = convertTimeFormat(course.duration);
              course.durationUnit = "";
            }
            startCourseList = [
              ...coursesList.filter((course) => course.status === "start"),
              ...startCourseList,
            ];
            inProgressCourseList = [
              ...coursesList.filter(
                (course) => course.status === "in-progress"
              ),
              ...inProgressCourseList,
            ];
            completedCourseList = [
              ...coursesList.filter((course) => course.status === "completed"),
              ...completedCourseList,
            ];
            overDueCourseList = [
              ...coursesList.filter((course) => course.status === "over-due"),
              ...overDueCourseList,
            ];
          }
        }
      }
      dispatch(getMyCoursesClear());
      // setAllCoursesList(allCourseList);
      // setStartCoursesList(startCourseList);
      // setInProgressCoursesList(inProgressCourseList);
      // setCompletedCoursesList(completedCourseList);
      // setOverDueCoursesList(overDueCourseList);
      // setIsLoading(false);
      // setIsCourseLoading(false);
    }
  }, [myCoursesData]);

  useEffect(() => {
    if (!_.isEmpty(myCourseRes)) {
      let allCourseList = [];
      let startCourseList = [];
      let inProgressCourseList = [];
      let completedCourseList = [];
      let overDueCourseList = [];
      console.log("MY COURSES", myCourseRes);
      if (myCourseRes.status === "success") {
        const cListPayload = myCourseRes.payload.payload;
        if (!_.isEmpty(cListPayload)) {
          const cList = cListPayload.courseList;
          for (let course of cList) {
            if (course.durationUnit === "Hours") {
              course.duration = convertHoursToMins(course.duration);
            }
            course.duration = convertTimeFormat(course.duration, true);
            course.durationUnit = "";
          }
          console.log("MY COURSES--", cList);
          if (!_.isEmpty(cList)) {
            allCourseList = cList;
            startCourseList = _.filter(
              cList,
              (c) => c.crs_status === "not-started"
            );
            inProgressCourseList = _.filter(
              cList,
              (c) =>
                c.crs_status === "in-progress" ||
                (c.crs_progress > 0 && c.crs_progress < 100)
            );
            completedCourseList = _.filter(
              cList,
              (c) => c.crs_status === "completed"
            );
            overDueCourseList = _.filter(
              cList,
              (c) => c.crs_status === "over-due" || c.crs_status === "overdue"
            );
          }
        }
      }
      setAllCoursesList(allCourseList);
      setStartCoursesList(startCourseList);
      setInProgressCoursesList(inProgressCourseList);
      setCompletedCoursesList(completedCourseList);
      setOverDueCoursesList(overDueCourseList);
      setIsLoading(false);
      setIsCourseLoading(false);
      dispatch(getProductCategoriesDataClear());
    }
  }, [myCourseRes]);

  // useEffect(() => {
  //   if (!_.isEmpty(myLearningPathsData)) {
  //     if (!_.isEmpty(myLearningPathsData?.payload?.payload)) {
  //       // console.log("learningpathdata", myLearningPathsData?.payload?.payload);
  //       const learning = myLearningPathsData?.payload?.payload;
  //       setAllLearningPathList(learning);
  //       setStartLearningPathList(
  //         learning.filter((course) => course.status === "start")
  //       );
  //       setInProgressLearningPathList(
  //         learning.filter((course) => course.status === "in-progress")
  //       );
  //       setCompletedLearningPathList(
  //         learning.filter((course) => course.status === "completed")
  //       );
  //       setOverDueLearningPathList(
  //         learning.filter((course) => course.status === "over-due")
  //       );
  //     }
  //     setIsLPLoading(false);
  //     dispatch(getMyLearningPathsClear());
  //   }
  // }, [myLearningPathsData]);

  useEffect(() => {
    if (!_.isEmpty(myNonOblpListing)) {
      setIsLPLoading(false);
      console.log("myLP:, ", myNonOblpListing);
      let responseList = myNonOblpListing;
      if (responseList.status === "success") {
        const payload = responseList.payload?.data;
        if (!_.isEmpty(payload)) {
          let learning = formatLPData(payload);

          setAllLearningPathList(learning);
          setStartLearningPathList(
            learning.filter((course) => course.status === "start")
          );
          setInProgressLearningPathList(
            learning.filter(
              (course) =>
                course.status === "in-progress" ||
                (course?.progress > 0 && course?.progress < 100)
            )
          );
          setCompletedLearningPathList(
            learning.filter((course) => course.status === "completed")
          );
          setOverDueLearningPathList(
            learning.filter(
              (course) =>
                course.status === "over-due" || course.status === "overdue"
            )
          );
        } else {
        }
      } else {
      }
      dispatch(getNonMyOBLPListingClear());
    }
  }, [myNonOblpListing]);

  const formatLPData = (lpData) => {
    let lpArr = [];
    let records = lpData.records;
    for (let lp of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = t("Explore");
      if (!_.isEmpty(lp.provider)) {
        tags.push(lp.provider.provider_display_name);
        logoURL = lp.provider.provider_img;
      }
      tags.push(`${"Action Path"}`);

      if (lp.course_count) {
        tags.push(`${lp.course_count} Course${lp.course_count > 1 ? "s" : ""}`);
      }
      if (lp.video_count) {
        tags.push(`${lp.video_count} Video${lp.video_count > 1 ? "s" : ""}`);
      }
      if (lp.level_count) {
        tags.push(`${lp.level_count} Level${lp.level_count > 1 ? "s" : ""}`);
      }
      if (lp.event_count) {
        tags.push(`${lp.event_count} Event${lp.event_count > 1 ? "s" : ""}`);
      }
      if (lp.duration) {
        tags.push(convertTimeFormat(lp.duration, true));
      }
      let priceInfo = getProcureInfo(lp.purchased_info);
      lp.priceInfo = priceInfo;
      lp.is_home = true;

      lpArr.push({
        id: lp?.id,
        is_like: lp?.is_like ? lp?.is_like : false,
        is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
        dbId: lp?.list_id,
        productType: "learningpath",
        productOrigin: lp?.origin,
        title: lp.name,
        logoURL: logoURL,
        logoAlText: "LP",
        bannerURL: lp.thumbnail,
        tagsArray: tags,
        description: lp.description,
        duration: "",
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: true,
        showBody: false,
        showFooter: true,
        progress: lp.learn_progress,
        btnTitle: btnTitle,
        btnAction: () => goToLPDetailUtil(lp, navigate),
        descAction: () => {},
        bannerAction: () => {},
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        priceInfo: "",
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        status: lp.status,
      });
    }
    return lpArr;
  };

  const setFavorite = (id) => {
    // console.log("setFAV_ID", id);
    // return;
    const postData = {
      course_id: {
        _id: {
          $oid: id,
        },
        bkmrk: true,
        type: pageType,
      },
    };
    // TODO: TO CHANGE AFTER USER ID CHANGES
    // dispatch(setFavoriteCourses({
    //     module: 'courseFavorite',
    //     token: localStorage.getItem(SessionKeys.API_TOKEN),
    //     postData
    // }));
  };

  const renderCoursesList = (courseList, type) => {
    return (
      <>
        {!isCourseLoading ? (
          <>
            {courseList.length > 0 ? (
              <SliderMyCoursesListing
                isOnboarding={false}
                coursesList={courseList}
                setFavoriteCourse={setFavorite}
                closeModal={closeChildModal}
                setCloseModal={setCloseChildModal}
                hasDescription={false}
                pageType="course"
                showBlankCard={true}
                courseType={type}
              />
            ) : (
              <div className="not-found mt-3">
                <div className="interboxes">
                  <NotFoundImage width={200} height={219} />
                  <p>
                    {type === "start" ? (
                      <>
                        <span>
                        {t("coursesThatAreAssignedToYou")} <br />
                        {t("click")}{" "}
                          <a
                            className="hyperlink-to"
                            onClick={() => {
                              navigate(`/learn/courses?tab=1`);
                            }}
                          >
                             {t("here")}
                          </a>{" "}
                          {t("toExploreCourses.")}
                        </span>
                      </>
                    ) : type === "all" ? (
                      <>
                        <span>
                        {t("coursesThatAreAssignedToYou2")}{" "}
                          <br />
                          {t("click")}{" "}
                          <a
                            className="hyperlink-to"
                            onClick={() => {
                              navigate(`/learn/courses?tab=1`);
                            }}
                          >
                            {t("here")}
                          </a>{" "}
                          {t("toExploreCourses.")}
                        </span>
                      </>
                    ) : (
                      <>
                        <span>
                        {t("coursesThatAre")} {type} {t("willAppearHere")}<br />
                          {t("click")}{" "}
                          <a
                            className="hyperlink-to"
                            onClick={() => {
                              navigate(`/learn/courses?tab=1`);
                            }}
                          >
                            {t("here")}
                          </a>{" "}
                          {t("toExploreCourses.")}
                        </span>
                      </>
                    )}
                  </p>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="row videolistbox">
              {[1, 2, 3].map((i) => {
                return <ShimmerCardBody key={`c-${type}-${i}`} />;
              })}
            </div>
          </>
        )}
      </>
    );
  };

  const redirectToViewAll = (type) => {
    if (type === "course") {
      navigate("/learn/courses?tab=2");
    } else {
      navigate("/learn/learningpath?tab=4");
    }
  };

  const renderLearningPathList = (learningPathList, type) => {
    return (
      <>
        {!isLPLoading ? (
          <>
            {learningPathList.length > 0 ? (
              <SliderMyLearningPathListing
                isOnboarding={false}
                learningPathList={learningPathList}
                setFavoriteCourse={setFavorite}
                closeModal={closeChildModal}
                setCloseModal={setCloseChildModal}
                hasDescription={false}
                pageType="learningPath"
                showBlankCard={true}
                learningType={type}
              />
            ) : (
              <div className="not-found mt-3">
                <div className="interboxes">
                  <NotFoundImage width={200} height={219} />
                  <p>
                    {type === "start" ? (
                      <>
                        <span>
                        {t("coursesThatAreAssignedToYou")} <br />
                        {t("click")}{" "}
                          <a
                            className="hyperlink-to"
                            onClick={() => {
                              navigate("/learn/learningpath?tab=3");
                            }}
                          >
                            {t("here")}
                          </a>{" "}
                          {t("toExploreLearningPaths")}
                        </span>
                      </>
                    ) : type === "all" ? (
                      <>
                        <span>
                        {t("learningPathsThatAreAssignedToYou")} <br />
                        {t("click")}{" "}
                          <a
                            className="hyperlink-to"
                            onClick={() => {
                              navigate("/learn/learningpath?tab=3");
                            }}
                          >
                            {t("here")}
                          </a>{" "}
                          {t("toExploreLearningPaths")}
                        </span>
                      </>
                    ) : (
                      <>
                        <span>
                        {t("learningPathsThatAre")} {type} {t("willAppearHere")}{" "}
                          <br />
                          {t("click")}{" "}
                          <a
                            className="hyperlink-to"
                            onClick={() => {
                              navigate("/learn/learningpath?tab=3");
                            }}
                          >
                           {t("here")}
                          </a>{" "}
                          {t("toExploreLearningPaths")}
                        </span>
                      </>
                    )}
                  </p>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="row videolistbox">
              {[1, 2, 3].map((i) => {
                return <ShimmerCardBody key={`c-${type}-${i}`} />;
              })}
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      {/* <Loader start={isLoading} /> */}
      <section className="my_onbording pt-5g pb-5g" id="myArea">
        <div className="container">
          <div>
            <div className="d-flex New_My_ara mb-4">
              <h3 className="lable-heading_search m-0">{t('myArea')}</h3>
            </div>
            <div className="rows my_courses">
              <Tabs defaultActiveKey="home" className="tabs-box-new">
                <Tab eventKey="home" title={t('all')}>
                  <div>
                    <div className="content-title d-flex justify-content-between pt-5">
                      <div className="my-area-title">{t('courses')}</div>
                      <button
                        className="view-all-btn"
                        onClick={() => redirectToViewAll("course")}
                      >
                        {t('viewAll')}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                            stroke="#415385"
                            strokeWidth="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    {renderCoursesList(allCoursesList, "all")}
                    {userRole === "realtor" ||
                    userRole === "customer" ||
                    userRole === "manager" ? (
                      <>
                        <div className="content-title d-flex justify-content-between pt-5">
                          <div className="my-area-title">{t('learningPaths')}</div>
                          <button
                            className="view-all-btn"
                            onClick={() => redirectToViewAll("lp")}
                          >
                            {t('viewAll')}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        {renderLearningPathList(allLearningPathList, "all")}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Tab>
                <Tab eventKey="start" title={t('yetToStart')}>
                  <div>
                    <div className="content-title d-flex justify-content-between pt-5">
                      <div className="my-area-title">{t('courses')}</div>
                      <button
                        className="view-all-btn"
                        onClick={() => redirectToViewAll("course")}
                      >
                        {t('viewAll')}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                            stroke="#415385"
                            strokeWidth="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                    </div>

                    {renderCoursesList(startCoursesList, "start")}
                    {userRole === "realtor" ||
                    userRole === "customer" ||
                    userRole === "manager" ? (
                      <>
                        <div className="content-title d-flex justify-content-between pt-5">
                          <div className="my-area-title">{t('learningPaths')}</div>
                          <button
                            className="view-all-btn"
                            onClick={() => redirectToViewAll("course")}
                          >
                            {t('viewAll')}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        {renderLearningPathList(startLearningPathList, "start")}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Tab>
                <Tab eventKey="inProgress" title={t('inProgress')}>
                  <div>
                    <div className="content-title d-flex justify-content-between pt-5">
                      <div className="my-area-title"> {t('courses')}</div>
                      <button
                        className="view-all-btn"
                        onClick={() => redirectToViewAll("course")}
                      >
                        {t('viewAll')}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                            stroke="#415385"
                            strokeWidth="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    {renderCoursesList(inProgressCoursesList, "in-progress")}
                    {userRole === "realtor" ||
                    userRole === "customer" ||
                    userRole === "manager" ? (
                      <>
                        <div className="content-title d-flex justify-content-between pt-5">
                          <div className="my-area-title"> {t('learningPaths')}</div>
                          <button
                            className="view-all-btn"
                            onClick={() => redirectToViewAll("lp")}
                          >
                            {t('viewAll')}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        {renderLearningPathList(
                          inProgressLearningPathList,
                          "in-progress"
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Tab>
                <Tab eventKey="completed" title={t('completed')}>
                  <div>
                    <div className="content-title d-flex justify-content-between pt-5">
                      <div className="my-area-title"> {t('courses')}</div>
                      <button
                        className="view-all-btn"
                        onClick={() => redirectToViewAll("course")}
                      >
                        {t('viewAll')}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                            stroke="#415385"
                            strokeWidth="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    {renderCoursesList(completedCoursesList, "completed")}
                    {userRole === "realtor" ||
                    userRole === "customer" ||
                    userRole === "manager" ? (
                      <>
                        <div className="content-title d-flex justify-content-between pt-5">
                          <div className="my-area-title"> {t('learningPaths')}</div>
                          <button
                            className="view-all-btn"
                            onClick={() => redirectToViewAll("lp")}
                          >
                            {t('viewAll')}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        {renderLearningPathList(
                          completedLearningPathList,
                          "completed"
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Tab>
                <Tab eventKey="overdue" title={t('overdue')}>
                  <div>
                    <div className="content-title d-flex justify-content-between pt-5">
                      <div className="my-area-title"> {t('courses')}</div>
                      <button
                        className="view-all-btn"
                        onClick={() => redirectToViewAll("course")}
                      >
                        {t('viewAll')}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                            stroke="#415385"
                            strokeWidth="1.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    {renderCoursesList(overDueCoursesList, "over-due")}
                    {userRole === "realtor" ||
                    userRole === "customer" ||
                    userRole === "manager" ? (
                      <>
                        <div className="content-title d-flex justify-content-between pt-5">
                          <div className="my-area-title"> {t('learningPaths')}</div>
                          <button
                            className="view-all-btn"
                            onClick={() => redirectToViewAll("lp")}
                          >
                            {t('viewAll')}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                stroke="#415385"
                                strokeWidth="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </button>
                        </div>
                        {renderLearningPathList(
                          overDueLearningPathList,
                          "over due"
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyAreaSection;
